module.exports = __webpack_public_path__ + "static/media/23-3.ff565e43.mp3";